import { ETypeOfCompetition } from '../../../components/pages/Registration/DefaultVacancy';

interface Competition { id: string; name: string }

export const savedCompetitionSelection = (types: Competition[] = []) => {
  const reserved = types.some((type) => /pcd|pppiq/i.test(type.name));
  if (reserved) return ETypeOfCompetition.SPECIAL_VACANCY;
  if (types.some((type) => /ufc/i.test(type.name))) return ETypeOfCompetition.UFC_SERVER_VACANCY;
  if (types.some((type) => /ampla/i.test(type.name))) return ETypeOfCompetition.FULL_VACANCY;
  return '';
};

// Legacy registrations can include Ampla alongside their reserved modality.
// Saving unrelated fields must not silently remove that stored relationship.
export const preserveUnchangedCompetition = (payload: FormData, original: Competition[] = []) => {
  const selected = payload.get('type_of_competition');
  if (!selected || !original.length) return;
  const selectedIds: string[] = JSON.parse(String(selected));
  const originalIds = original.map((type) => type.id).sort();
  const reservedIds = original.filter((type) => !/ampla/i.test(type.name)).map((type) => type.id).sort();
  const nextIds = [...selectedIds].sort();
  if (JSON.stringify(nextIds) === JSON.stringify(originalIds) ||
    (reservedIds.length > 0 && JSON.stringify(nextIds) === JSON.stringify(reservedIds))) {
    payload.delete('type_of_competition');
  }
};
